// ✅ CardShopRepository.js (FULL - variant safe + backward compatible)
import { CardShopStruct } from "../structs/CardShopStruct";

export class CardShopRepository {
    static getAll() {
        return JSON.parse(localStorage.getItem("card_shop")) || [];
    }

    static _key(product) {
        if (!product) return "";
        const pid = product?.id != null ? String(product.id) : "";
        const vid = product?.variant_id != null ? String(product.variant_id) : "";
        return vid ? `${pid}::${vid}` : pid;
    }

    // ✅ backward compatible: if id is number => find first matching product.id
    static getItem(id) {
        const list = this.getAll();
        if (!list.length) return false;

        const find = list.find((item) => item?.product?.id === id);
        return find || false;
    }

    // ✅ variant-safe: find by computed key
    static getItemByKey(key) {
        const list = this.getAll();
        if (!list.length) return false;

        const find = list.find((item) => this._key(item?.product) === key);
        return find || false;
    }

    static deleteAll() {
        return localStorage.removeItem("card_shop");
    }

    // ✅ variant-safe add (if same key exists, increase that line only)
    static addCardShop(productItem) {
        if (!productItem) return;

        let list = this.getAll();
        const key = this._key(productItem);
        let check = false;

        list.forEach((item) => {
            if (this._key(item?.product) === key) {
                item.count = parseFloat((parseFloat(item.count || 0) + 1).toFixed(3));
                check = true;
            }
        });

        if (!check) {
            let cardShopStruct = new CardShopStruct();
            cardShopStruct.product = productItem;
            cardShopStruct.count = parseFloat((1).toFixed(3));
            list.push(cardShopStruct);
        }

        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    // ✅ variant-safe decrease
    static decreaseCardShop(productItem) {
        if (!productItem) return;

        let list = this.getAll();
        const key = this._key(productItem);

        list.forEach((item, i) => {
            if (this._key(item?.product) === key) {
                if (item.count > 1) {
                    item.count = parseFloat((item.count - 1).toFixed(3));
                } else {
                    list.splice(i, 1);
                }
            }
        });

        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    // ✅ backward compatible update by product.id (will update FIRST match by product.id)
    static updateCount(productItem, newCount) {
        if (!productItem) return;

        let list = this.getAll();
        const index = list.findIndex((item) => item?.product?.id === productItem.id);

        if (index !== -1) {
            if (newCount <= 0) {
                list.splice(index, 1);
            } else {
                list[index].count = parseFloat(Number(newCount).toFixed(3));
            }
        } else if (newCount > 0) {
            let cardShopStruct = new CardShopStruct();
            cardShopStruct.product = productItem;
            cardShopStruct.count = parseFloat(Number(newCount).toFixed(3));
            list.push(cardShopStruct);
        }

        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    // ✅ variant-safe update by key
    static updateCountByKey(key, productItem, newCount) {
        if (!productItem) return;

        let list = this.getAll();
        const index = list.findIndex((item) => this._key(item?.product) === key);

        if (index !== -1) {
            if (newCount <= 0) {
                list.splice(index, 1);
            } else {
                list[index].count = parseFloat(Number(newCount).toFixed(3));
            }
        } else if (newCount > 0) {
            let cardShopStruct = new CardShopStruct();
            cardShopStruct.product = productItem;
            cardShopStruct.count = parseFloat(Number(newCount).toFixed(3));
            list.push(cardShopStruct);
        }

        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    // ✅ backward compatible: remove by product.id (removes ALL variants too)
    static removeItem(id) {
        let list = this.getAll();
        list = list.filter((item) => item?.product?.id !== id);
        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    // ✅ variant-safe: remove only one variant line
    static removeItemByKey(key) {
        let list = this.getAll();
        list = list.filter((item) => this._key(item?.product) !== key);
        localStorage.setItem("card_shop", JSON.stringify(list));
    }
}
